import { render, staticRenderFns } from "./pDiy.vue?vue&type=template&id=444e35ce"
import script from "./pDiy.vue?vue&type=script&lang=js"
export * from "./pDiy.vue?vue&type=script&lang=js"
import style0 from "./pDiy.vue?vue&type=style&index=0&id=444e35ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports